import { render, staticRenderFns } from "./OrderPanel.vue?vue&type=template&id=2fb97a6c&scoped=true&"
import script from "./OrderPanel.vue?vue&type=script&lang=ts&"
export * from "./OrderPanel.vue?vue&type=script&lang=ts&"
import style0 from "./OrderPanel.vue?vue&type=style&index=0&id=2fb97a6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb97a6c",
  null
  
)

export default component.exports